﻿import * as eventTypes from '../map/utils/eventTypes';
import * as actionTypes from '../map/utils/actionTypes';
import * as layerTypes from '../map/utils/layerTypes';
import Contextual from './controls/contextual/contextual';
export default class FeatureActionHandler {
    constructor(mapControl, classId, mapContainer, generalSettingsHandler, rootURL, resourcesHandler, addLayers, editControl, multipleAddLayers, generalActionHandler) {
        this.mapControl = mapControl;
        this.classId = classId;
        this.mapContainer = mapContainer;
        this.generalSettingsHandler = generalSettingsHandler;
        this.rootURL = rootURL;
        this.resourcesHandler = resourcesHandler;
        this.addLayers = addLayers;
        this.multipleAddLayers = multipleAddLayers;
        this.editControl = editControl;
        this.generalActionHandler = generalActionHandler;
        this.featureMenuElementId = 'xpmap-feature-menu-wrapper-' + this.mapControl.mapId + '-' + this.classId;
        this.featureInfoWrapper = 'xpmap-feature-info-wrapper-' + this.mapControl.mapId + '-' + this.classId;
        this.cancelFeatureInfoId = 'xpmap-cancel-feature-info-' + this.mapControl.mapId + '-' + this.classId;
        this.featureInfoContainer = 'xpmap-feature-info-container-' + this.mapControl.mapId + '-' + this.classId;
        this.contextMenu = null;
        this.disabled = false;
        this.contextMenuFeatureId = null;
        this.contextMenuLayerId = null;
        this.actionItems = {};
        this.actionConfigs = {};
        this.featureMoreActionsMenuId = 'xpmap-feature-more-actions-' + this.mapControl.mapId + '-' + this.classId;
    }

    init() {
        this.mapContainer.append(this._getFeatureMenuTemplate());
        $event.register(eventTypes.FEATURE_SELECTION_CHANGED, this._getFeatureSelectionChangedHandler(), this, this.classId);
        $event.register(eventTypes.RIGHT_CLICK, this._getMouseRightClickActionHandler(), this, this.classId);
        $event.register(eventTypes.MAP_MULTIPLE_LAYER_SELECTION, this._getMultipleLayerSelectionHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, this._getFeatureToolsVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.CLEAR_MULTIPLE_SELECTION, this._getClearMultipleSelectionHandler(), this, this.classId);

        $('body').on('keyup', (e) => {
            if (e.key === 'Escape' || e.keyCode === 27) { //esc key
                this._removeContextMenu();
                this.mapControl.clearSelection();
            }
        });
    }

    _getClearMultipleSelectionHandler() {
        let handler = (eventName, event, sender) => {
            this._hideMultipleSelection();
        };

        return handler;
    }

    _getFeatureToolsVisibilityChangedHandler() {
        let handler = (eventName, event, sender) => {
            if (event.visible) {
                this._removeContextMenu();
                this.disabled = true;
            } else {
                this.disabled = false;
            }
        };

        return handler;
    }

    _getMouseRightClickActionHandler() {
        if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT) {

            var handler = (eventName, data, sender) => {
                if (this.selectedFeatureId != null) {
                    this._showContextMenu(data.originalEvent).then((result) => {
                        this.contextMenu = result;
                    });
                }
            };

            return handler;
        }

        return function (eventName, event, sender) { };
    }

    _showContextMenu(event) {
        return new Promise((resolve, reject) => {
            if (this.disabled) {
                resolve(null);
            }

            this.contextMenuFeatureId = this.selectedFeatureId;
            this.contextMenuLayerId = this.selectedFeatureLayerId;

            var items = [];

            this._extractFeatureActions(this.selectedFeatureLayerId, this.selectedFeatureLayer).then(() => {
                var customActionConfigs = this.actionConfigs["layer-" + this.selectedFeatureLayerId.toString()];

                var selectedFeatures = this.mapControl.getAllSelectedFeatures(this.selectedFeatureLayerId);

                if (customActionConfigs != null) {
                    items.push(...this._getFeatureContextMenuItems(customActionConfigs, selectedFeatures));
                }

                var selectionCount = selectedFeatures.length;

                if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT) {
                    if (selectionCount > 1) {
                        items.push({
                            label: this.resourcesHandler.get("Fit elements"),
                            cssIcon: 'fal fa-compress-arrows-alt',
                            onClick: (itemKey, opt, e) => {
                                if (this.selectedFeatureId != null) {
                                    this.mapControl.showSelectedFeatures(this.selectedFeatureLayerId);
                                }
                            }
                        });

                        if (this.multipleAddLayers != null && this.multipleAddLayers.length > 0) {
                            items.push({
                                label: this.resourcesHandler.get("CopyToLayer"),
                                cssIcon: 'fal fa-copy',
                                onClick: (itemKey, opt, e) => {
                                    if (this.selectedFeatureId != null) {
                                        this._handleCopyToLayerMultiple(this.selectedFeatureLayerId);
                                    }
                                }
                            });
                        }
                    } else {
                        if (this.addLayers != null && this.addLayers.length > 0) {
                            items.push({
                                label: this.resourcesHandler.get("CopyToLayer"),
                                cssIcon: 'fal fa-copy',
                                onClick: (itemKey, opt, e) => {
                                    if (this.selectedFeatureId != null) {
                                        this._handleCopyToLayer(this.selectedFeatureLayerId);
                                    }
                                }
                            });
                        }

                        if (this.selectedFeatureLayerId == layerTypes.MEASUREMENTS || this.selectedFeatureLayerId == layerTypes.REDLINE || this.selectedFeatureLayerId == layerTypes.DIMENSIONING) {
                            items.push({
                                label: this.resourcesHandler.get("EDIT_LAYER_GEOMETRY"),
                                cssIcon: 'fal fa-pencil-ruler',
                                onClick: (itemKey, opt, e) => {
                                    if (this.selectedFeatureId != null) {
                                        this._handleEditTemporaryVectorFeature(this.selectedFeatureLayerId, this.selectedFeatureId);
                                    }
                                }
                            });
                        }

                        if (this.selectedFeatureLayerId == layerTypes.ANNOTATION) {
                            items.push({
                                label: this.resourcesHandler.get("Remove"),
                                cssIcon: 'fal fa-trash',
                                onClick: (itemKey, opt, e) => {
                                    if (this.selectedFeatureId != null) {
                                        let layer = this.mapControl.layerHandler.getLayerById(layerTypes.ANNOTATION)[0];
                                        if (layer) {
                                            let source = layer.getSource();
                                            let feature = source.getFeatures().find(f => f.get('id') == this.selectedFeatureId);
                                            if (feature) {
                                                source.removeFeature(feature);
                                            }
                                        }
                                    }
                                    this._removeContextMenu();
                                    this.mapControl.clearSelection();
                                }
                            });
                        }

                        if (this.generalActionHandler.showFeatureInfo) {
                            items.push({
                                label: this.resourcesHandler.get("Feature Information"),
                                cssIcon: 'fal fa-info-circle',
                                onClick: (itemKey, opt, e) => {
                                    if (this.selectedFeatureId != null) {
                                        this._showFeatureInfo(this.selectedFeatureLayerId, this.selectedFeatureId);
                                    }
                                }
                            });
                        }

                        items.push({
                            label: this.resourcesHandler.get("Fit element"),
                            cssIcon: 'fal fa-compress-arrows-alt',
                            onClick: (itemKey, opt, e) => {
                                if (this.selectedFeatureId != null) {
                                    this.mapControl.fitFeature(this.selectedFeatureLayerId, this.selectedFeatureId);
                                }
                            }
                        });
                    }

                    items.push({ type: 'seperator' });
                }

                if (selectionCount > 1) {
                    items.push({
                        label: this.resourcesHandler.get("Clear selections"),
                        cssIcon: 'fal fa-times-square',
                        onClick: (itemKey, opt, e) => {
                            this.mapControl.clearSelection();
                            this._deselectAllMultipleLayerSelections();
                        }
                    });
                } else {
                    items.push({
                        label: this.resourcesHandler.get("Clear selection"),
                        cssIcon: 'fal fa-times-square',
                        onClick: (itemKey, opt, e) => {
                            this.mapControl.clearSelection();
                            this._deselectAllMultipleLayerSelections();
                        }
                    });
                }

                if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.CLICK || this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.DOUBLE_CLICK) {
                    if (customActionConfigs != null && customActionConfigs.length > 0 && items.length > 1) {
                        $event.notify("contextMenuVisibilityChanged", { visible: true }, this, this.classId);
                        resolve(new Contextual({
                            isSticky: false,
                            minWidth: '250px',
                            width: 'auto',
                            target: this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT ? null : this.mapControl.id,
                            owner: this,
                            event: event,
                            items: items
                        }));
                    } else {
                        resolve(null);
                    }
                } else {
                    resolve(new Contextual({
                        isSticky: false,
                        minWidth: '250px',
                        width: 'auto',
                        target: this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT ? null : this.mapControl.id,
                        owner: this,
                        event: event,
                        items: items
                    }));
                }
            });
        });
    }

    _handleEditTemporaryVectorFeature(selectedFeatureLayerId, selectedFeatureId) {
        this.mapControl.generalActionHandler.startEdit(selectedFeatureLayerId, [this.mapControl.getFeatureById(selectedFeatureLayerId, selectedFeatureId)], true);
        this._removeContextMenu();
    }

    _showFeatureInfo(selectedFeatureLayerId, selectedFeatureId) {
        document.getElementById(this.featureMenuElementId).innerHTML = this._getFeatureInfoTemplate();

        let feature = this.mapControl.getFeatureById(selectedFeatureLayerId, selectedFeatureId);

        if (feature != null) {
            let properties = feature.getProperties();

            let keys = Object.keys(properties);

            let template = ``;

            keys.forEach(key => {
                let item = properties[key];

                if (item != null && item.getExtent != null) {
                    template += `<div class="form-row col-12"><label style="font-weight: bold;">Geometry Type: </label><label>` + item.getType() + `</label></div>`;
                    template += `<div class="form-row col-12"><label style="font-weight: bold;">Geometry: </label><label>` + this.mapControl.geometryToWkt(item) + `</label></div>`;
                } else if (item != null && key != 'xp_allow_edit' && key != 'xp_allow_del' && key != 'xstate'){
                    template += `<div class="form-row col-12"><label style="font-weight: bold;">` + key + `: </label><label>` + item + `</label></div>`;
                }
            });

            document.getElementById(this.featureInfoContainer).innerHTML = template;
        }

        document.getElementById(this.cancelFeatureInfoId).addEventListener('click', () => {
            document.getElementById(this.featureMenuElementId).innerHTML = '';
        });
    }

    _extractFeatureActions(layerId, layer) {
        if (this.actionItems["layer-" + layerId] == null) {
            this.actionItems["layer-" + layerId] = [];
            this.actionConfigs["layer-" + layerId] = [];

            // Actiuni configurate au numai layerele reale din harta, care au id numeric. Analizele (id GUID)
            // si layerele-unealta (MEASUREMENTS/REDLINE/DIMENSIONING/... = id text) ar trimite idMapLayer=0,
            // iar endpoint-ul arunca pe 0 - deci nici nu mai apelam.
            let idMapLayer = layerId == null || layerId === '' ? NaN : Number(layerId);

            if (!Number.isInteger(idMapLayer) || layer.get('temporarySettings') != null) {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            } else {
                let getLayerActionsUrl = this.rootURL + 'Map/GetLayerElementActions?idMap=' + this.mapControl.mapId + '&idMapLayer=' + layerId;
                var data = {};
                data.otherParams = layer.get('otherParams');

                return new Promise((resolve, reject) => {
                    $.ajax({
                        type: "POST",
                        url: getLayerActionsUrl,
                        async: false,
                        data: JSON.stringify(data),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null && result.length > 0) {
                                this.actionConfigs["layer-" + layerId] = result;
                                this._collectFeatureActionItems(result, this.actionItems["layer-" + layerId]);
                            }
                            resolve();
                        },
                        error: (e) => {
                            resolve();
                        }
                    });
                });
            }
        } else {
            return new Promise((resolve, reject) => {
                resolve();
            });
        }
    }

    _collectFeatureActionItems(actionConfigs, target) {
        actionConfigs.forEach(actionConfig => {
            if (actionConfig.SubType == 'GROUP') {
                this._collectFeatureActionItems(actionConfig.Items || [], target);
            } else if (actionConfig.SubType != 'SEPARATOR') {
                target.push(this._getStandardActionItem(actionConfig));
            }
        });
    }

    _getFeatureContextMenuItems(actionConfigs, selectedFeatures) {
        let items = [];

        actionConfigs.forEach(actionConfig => {
            if (actionConfig.SubType == 'GROUP') {
                let children = this._getFeatureContextMenuItems(actionConfig.Items || [], selectedFeatures);
                if (children.length > 0) {
                    items.push({
                        type: 'submenu',
                        label: this._getContextActionLabel(actionConfig),
                        cssIcon: actionConfig.Icon || '',
                        items: children
                    });
                }
                return;
            }

            if (actionConfig.SubType == 'SEPARATOR') {
                if (items.length > 0 && items[items.length - 1].type != 'seperator') {
                    items.push({ type: 'seperator' });
                }
                return;
            }

            let action = this._getStandardActionItem(actionConfig);
            if (action.minSelection > selectedFeatures.length || action.maxSelection < selectedFeatures.length) {
                return;
            }

            let subType = action.subType;
            let permReqType = action.permReqType;
            if (subType == 'EDIT_LAYER_GEOMETRY' && !selectedFeatures.every(f => f.get('xp_allow_edit') == 1)) {
                return;
            }
            if (subType == 'EDIT' && permReqType == 1 && !selectedFeatures.every(f => f.get('xp_allow_edit') == 1)) {
                return;
            }
            if (subType == 'DELETE' && !selectedFeatures.every(f => f.get('xp_allow_del') == 1)) {
                return;
            }

            items.push({
                label: this.resourcesHandler.get(action.name),
                cssIcon: action.icon,
                onClick: action.callback
            });
        });

        while (items.length > 0 && items[items.length - 1].type == 'seperator') {
            items.pop();
        }
        return items;
    }

    _getContextActionLabel(actionConfig) {
        let text = actionConfig.Text != null ? actionConfig.Text.toString().trim() : '';
        if (text != '' && text != actionConfig.SubType) {
            return this.resourcesHandler.get(text);
        }
        if (actionConfig.Title != null && actionConfig.Title.toString().trim() != '') {
            return actionConfig.Title;
        }
        return this.resourcesHandler.get('ActionSubType_' + actionConfig.SubType);
    }

    _getStandardActionItem(actionConfig) {
        const config = actionConfig;
        var actionHandler = (itemKey, opt, e) => {
            if (config.SubType == "EDIT_LAYER_GEOMETRY") {
                this.mapControl.generalActionHandler.startEdit(config.IdMapLayer, undefined, true);
                this._removeContextMenu();
            }
            else if (config.SubType == "DELETE") {
                let deleteLayerId = this.selectedFeatureLayerId;
                let deleteFeatureId = this.selectedFeatureId;

                confirmDialog.fire({
                    title: this.resourcesHandler.get('DeleteItemTitle'),
                    text: this.resourcesHandler.get('DeleteItemContent'),
                }).then((result) => {
                    if (result.value) {
                        var featureInfo = null;

                        let selectedFeaturesIds = this.mapControl.getAllSelectedFeatures(deleteLayerId);

                        if (selectedFeaturesIds != null && selectedFeaturesIds.length > 1) {
                            let deletedDetails = this.mapControl.getAllSelectedFeatureDetails(config.IdMapLayer);
                            this.mapControl.removeFeatures(deletedDetails);

                            // Scoatem din arbore fiecare element șters.
                            if (deletedDetails != null) {
                                deletedDetails.forEach(detail => {
                                    let idField = this.mapControl.getLayer(deleteLayerId).get('idField');
                                    this._removeFeatureFromTree(deleteLayerId, detail.get(idField));
                                });
                            }
                        } else if (deleteFeatureId != null) {
                            var featureInfo = this.mapControl.getFeatureDetails(deleteLayerId, deleteFeatureId);
                            if (featureInfo != null) {
                                featureInfo.layerId = deleteLayerId;
                                this.mapControl.removeFeatures([featureInfo]);

                                // Scoatem elementul șters din arbore.
                                this._removeFeatureFromTree(deleteLayerId, deleteFeatureId);
                            }
                        }
                    }
                });
            }
            else if (config.SubType == 'EDIT') {
                var _url = this.rootURL + 'EntityForm/EntityFormRuntime?context=modal&idForm=' + config.IdFormTarget;

                _url += '&idApp=' + xapp.currentApp;

                var layer = this.mapControl.layerSettingsHandler.getLayerSettings(this.selectedFeatureLayerId);
                if (layer != null && layer.IdExtConn != null) {
                    _url += "&IdExtConn=" + layer.IdExtConn;
                }

                let selectedFeaturesIds = this.mapControl.getAllSelectedFeatures(this.selectedFeatureLayerId);

                if (selectedFeaturesIds != null && selectedFeaturesIds.length > 1) {
                    let ids = [];

                    selectedFeaturesIds.forEach(feature => {
                        ids.push(feature.getId());
                    });

                    window.featuresToBeProcessed = { features: ids, layerId: this.selectedFeatureLayerId };
                    _url += '&fromActionType=EDIT_MULTI';
                } else {
                    if (this.selectedFeatureId == null) {
                        return;
                    } else {
                        _url += '&pkVal=' + this.selectedFeatureId;
                    }
                }

                var data = null;
                if (config.OtherParams != null) {
                    var postData = {};
                    postData.otherParams = config.OtherParams;
                    data = JSON.stringify(postData);
                }
                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                showModalWindow(_url, config.Text, config.Icon, width, height, data);
            }
            else if (config.SubType == 'FormWf') {
                if (this.selectedFeatureId == null) {
                    return;
                }

                var _url = this.rootURL + 'UIAction/GetFormWFRun?idAction=' + config.Id;

                if (config.Content != null && config.Content.trim() != '') {
                    let paramsMap = JSON.parse(config.Content);
                    let params = {};
                    let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                    if (paramsMap.length > 0) {
                        paramsMap.forEach(param => {
                            params[param] = selectedFeature.get(param);
                        });
                    }

                    _url += '&parameters=' + JSON.stringify(params);
                } else {
                    let paramsMap = this.getURLParams(config.Url);
                    let params = {};
                    let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                    if (paramsMap.length > 0) {
                        paramsMap.forEach(param => {
                            params[param] = selectedFeature.get(param);
                        });
                    }

                    _url += '&parameters=' + JSON.stringify(params);
                }

                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                showModalWindow(_url, config.Text, config.Icon, width, height);
            }
            else if (config.SubType == 'URL') {
                if (this.selectedFeatureId == null) {
                    return;
                }

                let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                let _url = config.Url;
                _url = _url.replaceAll('{ROOT_URL}', rootURL);

                if (selectedFeature != null) {
                    let propertyKeys = Object.keys(selectedFeature.getProperties());

                    propertyKeys.forEach(key => {
                        let keyValue = selectedFeature.get(key);

                        if (keyValue != null) {
                            _url = _url.replaceAll('{' + key + '}', keyValue);
                        }
                    });
                }

                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                showModalWindow(_url, config.Text, config.Icon, width, height);
            }
            else if (config.SubType == 'FORM') {
                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                if (this.selectedFeatureId == null) {
                    return;
                }

                var _url = this.rootURL + 'EntityForm/EntityFormRuntime?context=modal';
                var needFields = false;

                //idform
                if (config.IdFormTarget != null && config.IdFormTarget != '') {
                    _url += '&idForm=' + config.IdFormTarget;
                } else {
                    needFields = true;
                }

                var layer = this.mapControl.layerSettingsHandler.getLayerSettings(this.selectedFeatureLayerId);
                if (layer != null && layer.IdExtConn != null) {
                    _url += "&IdExtConn=" + layer.IdExtConn;
                }

                let selectedFeaturesIds = this.mapControl.getAllSelectedFeatures(this.selectedFeatureLayerId);

                if (config.NewRecord) {
                    _url += '&pkValCurrent=' + this.selectedFeatureId;
                }
                else if (selectedFeaturesIds != null && selectedFeaturesIds.length > 1) {
                    let ids = [];

                    selectedFeaturesIds.forEach(feature => {
                        ids.push(feature.getId());
                    });

                    window.featuresToBeProcessed = { features: ids, layerId: this.selectedFeatureLayerId };
                    _url += '&fromActionType=EDIT_MULTI';
                }
                else {
                    if (config.IdFieldTarget != null) {
                        needFields = true;
                    }
                    else {
                        _url += '&pkVal=' + this.selectedFeatureId;
                    }
                }
                _url += '&idaction=' + config.Id;
                // + '&pkValCurrent=' + this.selectedFeatureId;
                //'&idForm=' + config.IdFormTarget + '&pkVal=';
                _url += '&idApp=' + xapp.currentApp;
                if (needFields) {
                    let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                    let layerSettings = this.mapControl.layerSettingsHandler.getLayerSettings(this.selectedFeatureLayerId);

                    let getFieldsUrl = this.rootURL + 'Entity/GetFields?id=' + layerSettings.Entity.Id;

                    $.ajax({
                        type: "GET",
                        url: getFieldsUrl,
                        async: false,
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            var entityFields = result;

                            if (config.IdFormFieldTarget != null && config.IdFormFieldTarget != '') {
                                var possibilities = entityFields.filter(row => { return row.Id == config.IdFormFieldTarget });
                                if (possibilities.length > 0) {
                                    var entityField = possibilities[0];
                                    _url += '&idForm=' + selectedFeature.get(entityField.FieldName);
                                }
                            }
                            if (config.IdFieldTarget != null && config.IdFieldTarget != '') {
                                var possibilities = entityFields.filter(row => { return row.Id == config.IdFieldTarget });
                                if (possibilities.length > 0) {
                                    var entityField = possibilities[0];
                                    _url += '&pkVal=' + selectedFeature.get(entityField.FieldName);
                                }
                            }
                            showModalWindow(_url, config.Text, config.Icon, width, height);
                        },
                        error: (e) => {
                            toastr.error(this.getResource('GetFieldError'));
                        }
                    });
                }
                else {
                    showModalWindow(_url, config.Text, config.Icon, width, height);
                }
            } else if (config.SubType == 'JS') {
                //TODO
                window['xp_map_layer_action_' + config.Id + '_onClick'](this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId));
            }
        }

        var maximumSelection = (actionConfig.MaxSel != null && actionConfig.MaxSel != '') ? actionConfig.MaxSel : Number.MAX_SAFE_INTEGER;
        var minimumSelection = (actionConfig.MinSel != null && actionConfig.MinSel != '') ? actionConfig.MinSel : 1;

        var item = {
            icon: actionConfig.Icon,
            className: actionConfig.ClassName,
            name: this.resourcesHandler.get(actionConfig.Text),
            callback: actionHandler,
            maxSelection: maximumSelection,
            minSelection: minimumSelection,
            subType: actionConfig.SubType,
            permReqType: actionConfig.PermReqType
        }

        return item;
    }

    _getMultipleLayerSelectionHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this._handleMultipleLayerSelection(data.features);
            }
        };

        return handler;
    }

    _handleCopyToLayer(selectedFeatureLayerId) {
        this._initModal(this.resourcesHandler.get('SelectTargetLayer'), '40%', 'auto', null, false);
        $('body').css('overflow', 'hidden');
        $('#multiple-layer-selection-modal-inner')[0].innerHTML = '';
        $('#multiple-layer-selection-modal-inner').append('<div id="multiple-layer-selection-copy-tree" style="overflow-x: hidden;"></div>');

        let treeData = [];
        let entityDetailsRequests = [];

        this.addLayers.forEach(action => {
            let layerSettings = this.mapControl.getLayerSettings(action.IdMapLayer);
            let entity = layerSettings.Entity;
            let sld = this.mapControl.getLayerStyle(action.IdMapLayer);
            let imageStyleUrl = null;

            if (sld != null) {
                let rules = sld.style.rules;
                if (rules != null & rules.length > 0) {
                    imageStyleUrl = this._getLegendImageURL(layerSettings, rules[0].name);
                }
            }

            treeData.push({
                name: this.resourcesHandler.get(layerSettings.Title),
                entityId: entity.Id,
                layerId: action.IdMapLayer,
                fid: action.IdMapLayer,
                type: 'layer',
                currentIdx: 1,
                imageStyleUrl: imageStyleUrl,
                action: action
            });

            entityDetailsRequests.push(this._getEntityDetails(entity.Id));
        });

        var dataSource = new kendo.data.HierarchicalDataSource({
            data: treeData,
            schema: {
                model: {
                    children: "items"
                }
            }
        });

        $('#multiple-layer-selection-copy-tree').kendoTreeView({
            loadOnDemand: false,
            dataSource: dataSource,
            dragAndDrop: false,
            dataTextField: 'name',
            template: (e) => {
                let item = e.item;
                let template = '<div class="legend-node" style="width:15rem;">';

                if (item.imageStyleUrl != null) {
                    template += '<img src="' + item.imageStyleUrl + '" style="width:auto; height:19px;">';
                }

                template += '<div class="ml-2" style="display: inline-table;  height: 1rem; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '">' + item.name + '</div>';

                template += '</div>';

                return template;
            },
            select: (e) => {
                let selectedItem = $('#multiple-layer-selection-copy-tree').data('kendoTreeView').dataItem(e.node);
                this.editControl.startEdit(selectedItem.layerId, selectedItem.action, null, null, this.mapControl.getAllSelectedFeatures(selectedFeatureLayerId));
                this.mapControl.refreshLayer(selectedFeatureLayerId);
                setTimeout(() => {
                    this._closeModal();
                }, 100);
            }
        });

        $('#multiple-layer-selection-copy-tree').css('border', 'none');
        $('#multiple-layer-selection-copy-tree').data("kendoTreeView").expand(".k-treeview-item");

        setTimeout(() => {
            this._centerModal();
        }, 100);
    }

    _handleCopyToLayerMultiple(selectedFeatureLayerId) {
        this._initModal(this.resourcesHandler.get('SelectTargetLayer'), '40%', 'auto', null, false);
        $('body').css('overflow', 'hidden');
        $('#multiple-layer-selection-modal-inner')[0].innerHTML = '';
        $('#multiple-layer-selection-modal-inner').append('<div id="multiple-layer-selection-copy-tree" style="overflow-x: hidden;"></div>');

        let treeData = [];
        let entityDetailsRequests = [];

        this.multipleAddLayers.forEach(action => {
            let layerSettings = this.mapControl.getLayerSettings(action.IdMapLayer);
            let entity = layerSettings.Entity;
            let sld = this.mapControl.getLayerStyle(action.IdMapLayer);
            let imageStyleUrl = null;

            if (sld != null) {
                let rules = sld.style.rules;
                if (rules != null & rules.length > 0) {
                    imageStyleUrl = this._getLegendImageURL(layerSettings, rules[0].name);
                }
            }

            treeData.push({
                name: this.resourcesHandler.get(layerSettings.Title),
                entityId: entity.Id,
                layerId: action.IdMapLayer,
                fid: action.IdMapLayer,
                type: 'layer',
                currentIdx: 1,
                imageStyleUrl: imageStyleUrl,
                action: action
            });

            entityDetailsRequests.push(this._getEntityDetails(entity.Id));
        });

        var dataSource = new kendo.data.HierarchicalDataSource({
            data: treeData,
            schema: {
                model: {
                    children: "items"
                }
            }
        });

        $('#multiple-layer-selection-copy-tree').kendoTreeView({
            loadOnDemand: false,
            dataSource: dataSource,
            dragAndDrop: false,
            dataTextField: 'name',
            template: (e) => {
                let item = e.item;
                let template = '<div class="legend-node" style="width:15rem;">';

                if (item.imageStyleUrl != null) {
                    template += '<img src="' + item.imageStyleUrl + '" style="width:auto; height:19px;">';
                }

                template += '<div class="ml-2" style="display: inline-table;  height: 1rem; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '">' + item.name + '</div>';

                template += '</div>';

                return template;
            },
            select: (e) => {
                let selectedItem = $('#multiple-layer-selection-copy-tree').data('kendoTreeView').dataItem(e.node);
                this.editControl.startEdit(selectedItem.layerId, selectedItem.action, null, null, this.mapControl.getAllSelectedFeatures(selectedFeatureLayerId));
                this.mapControl.refreshLayer(selectedFeatureLayerId);
                setTimeout(() => {
                    this._closeModal();
                }, 100);
            }
        });

        $('#multiple-layer-selection-copy-tree').css('border', 'none');
        $('#multiple-layer-selection-copy-tree').data("kendoTreeView").expand(".k-treeview-item");

        setTimeout(() => {
            this._centerModal();
        }, 100);
    }

    _handleMultipleLayerSelection(features) {
        $('.toolbar-selected-items-wrapper')[0].innerHTML = '';
        $('.toolbar-selected-items-wrapper').append('<div id="multiple-layer-selection-tree" style="overflow-x: hidden; min-width: 17rem;"></div>');
        $('.map-toolbar-item.clear-selection').show();
        $(".map-toolbar-selection-list").addClass('joined');
        let structuredData = {};

        features.forEach(feature => {
            if (this.mapControl.selectionHandler.selectionHolder.layers[feature.layerId] != null) {
                let selectionLayer = this.mapControl.getLayerSettings(feature.layerId);

                if (structuredData[feature.layerId] == null) {
                    structuredData[feature.layerId] = {
                        _displayName: this.resourcesHandler.get(selectionLayer.Title),
                        entityId: selectionLayer.Entity != null ? selectionLayer.Entity.Id : null,
                        layerId: feature.layerId,
                        items: [],
                        fid: feature.layerId,
                        type: 'layer',
                        currentIdx: 1
                    }
                } else {
                    structuredData[feature.layerId].currentIdx++;
                }

                let featureClone = {};

                feature.getKeys().forEach(featureKey => {
                    featureClone[featureKey] = feature.get(featureKey);
                });

                featureClone.layerId = feature.layerId;
                featureClone.featureIdentifier = feature.get(this.mapControl.getLayer(feature.layerId).get("idField"));
                featureClone._displayName = structuredData[feature.layerId]._displayName + ' ' + structuredData[feature.layerId].currentIdx;
                featureClone.originalFeature = feature;

                // Entitatea poate fi deja în selecția curentă (ex: selecție
                // multiplă peste care se face o nouă selecție); marcăm starea ca
                // să apară bifată în arbore, nu ca neselectată.
                let holderLayer = this.mapControl.selectionHandler.selectionHolder.layers[feature.layerId];
                featureClone.alreadySelected = holderLayer != null && holderLayer.features != null && featureClone.featureIdentifier in holderLayer.features;

                if (selectionLayer.Tooltip != null && selectionLayer.Tooltip.length > 0) {
                    featureClone._displayName = this._getTooltipContent(selectionLayer.Tooltip, featureClone, this.mapControl.selectionHandler.selectionHolder.layers[feature.layerId].layer.get('interpretation'));
                }

                structuredData[feature.layerId].items.push(featureClone);
            }
        });

        let treeData = [];
        let entityDetailsRequests = [];
        let actionRequests = [];

        Object.keys(structuredData).forEach(key => {
            if (structuredData[key].entityId){
                entityDetailsRequests.push(this._getEntityDetails(structuredData[key].entityId));
            }

            // Preîncărcăm acțiunile fiecărui strat ca să putem randa butoanele de
            // acțiune per element în arbore (cache-uite în this.actionItems).
            let treeLayer = this.mapControl.getLayer(key);
            if (treeLayer != null) {
                actionRequests.push(this._extractFeatureActions(key, treeLayer));
            }
        });

        Promise.all(actionRequests).then(() => Promise.all(entityDetailsRequests)).then((result) => {
            if (result != null && result.length > 0) {
                result.forEach(resultItem => {
                    if (resultItem != null && resultItem.length > 0) {
                        let nameField = resultItem.filter(row => { return row.SpecialFieldType == 'NAME_FIELD' });

                        if (nameField != null && nameField.length > 0) {
                            let currentItemKeys = Object.keys(structuredData).filter(row => { return structuredData[row].entityId == resultItem[0].IdEntity });

                            if (currentItemKeys != null && currentItemKeys.length > 0) {
                                currentItemKeys.forEach(currentItemKey => {
                                    structuredData[currentItemKey].items.forEach(featureItem => {
                                        if (featureItem[nameField[0].FieldName] != null && featureItem[nameField[0].FieldName].toString().trim() != '') {
                                            featureItem._displayName = featureItem[nameField[0].FieldName].toString();
                                        }
                                    });
                                });
                            }
                        }
                    }
                });
            }

            Object.keys(structuredData).forEach(key => {
                let styleId = this.mapControl.getLayerSettings(key).IdDefaultStyle;
                let currentLayer = this.mapControl.getLayer(key);

                if (styleId != null && currentLayer != null) {
                    structuredData[key].items.forEach(item => {
                        let classIdx = 0;
                        if (currentLayer.getStyle && typeof currentLayer.getStyle == 'function') {
                            let symbols = currentLayer.getStyle()(item.originalFeature);

                            if (symbols.length > 0) {
                                symbols.forEach(symbol => {
                                    if (symbol.getZIndex() < 0 && symbol.getZIndex() != 100) {
                                        classIdx = -symbol.getZIndex();
                                    }
                                });
                            }
                        }

                        item.imageStyleUrl = this._getStylePreview(styleId, classIdx);
                    });
                }

                treeData.push(structuredData[key]);
            });

            var dataSource = new kendo.data.HierarchicalDataSource({
                data: treeData,
                schema: {
                    model: {
                        children: "items"
                    }
                }
            });

            $('#multiple-layer-selection-tree').kendoTreeView({
                loadOnDemand: false,
                dataSource: dataSource,
                dragAndDrop: false,
                select: function (e) {
                    e.preventDefault();
                },
                dataTextField: '_displayName',
                template: (e) => {
                    let item = e.item;
                    let template = '<div class="legend-node" style="display: flex; align-items: center; width:17rem;">';

                    // Bifa se afișează prima, la stânga de tot (înaintea imaginii
                    // de previzualizare a stratului), lăsând dreapta liberă.
                    if (item.type == 'layer') {
                        if (this.mapControl.selectionHandler.selectionHolder.allowMultiple) {
                            template += '<span class="btn btn-secondary fal fa-check-double select-layer-btn" style="flex: 0 0 auto; min-width: 1rem; width: 1rem; height: 1rem; line-height: 0.7rem; font-size: 0.6rem; color: white; font-weight: 600; margin-right: 0.5rem;"></span>';
                        }
                    } else {
                        template += '<span class="btn ' + (item.alreadySelected ? 'btn-primary' : 'btn-secondary') + ' fal fa-check select-feature-btn" style="flex: 0 0 auto; min-width: 1rem; width: 1rem; height: 1rem; line-height: 0.7rem; font-size: 0.6rem; color: white; font-weight: 600; margin-right: 0.5rem;"></span>';
                    }

                    if (item.imageStyleUrl != null) {
                        template += '<img src="' + item.imageStyleUrl + '" style="flex: 0 0 auto; width:auto; height:19px;">';
                    }

                    if (item.type == 'layer') {
                        template += '<div data-layer="' + item.layerId + '" class="ml-2" style="display: flex; align-items: center; width: 98%; font-size: 0.75rem; white-space: break-spaces; font-weight: 700 !important;">';
                        // currentIdx = numărul de entități intersectate din acest strat.
                        template += '<span>' + item._displayName + (item.currentIdx != null ? ' (' + item.currentIdx + ')' : '') + '</span>';
                        template += '</div>';
                    } else {
                        template += '<div data-layer="' + item.layerId + '" data-feature="' + item.featureIdentifier + '"' + (item.alreadySelected ? ' old-state="2"' : '') + ' class="ml-2 data-feature" style="display: flex; align-items: center; width: 95%; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '">';
                        template += '<span>' + item._displayName + '</span>';
                        template += this._getFeatureRowActionsTemplate(item);
                        template += '</div>';
                    }

                    template += '</div>';

                    return template;
                }
            });

            $('#multiple-layer-selection-tree').css('border', 'none');
            $('#multiple-layer-selection-tree').data("kendoTreeView").expand(".k-treeview-item");

            setTimeout(() => {
                $('.map-toolbar-selected-items').show();

                $('#multiple-layer-selection-tree .k-treeview-lines').children('.k-treeview-item').css('margin-bottom', '1rem');

                $('.select-layer-btn').on('click', (evt) => {
                    let currentTarget = evt.currentTarget;
                    let layerId = $(currentTarget).closest('.legend-node').find('[data-layer]').attr('data-layer');
                    let featureIds = [];

                    let items = $(currentTarget).closest('.k-treeview-item').find('.k-treeview-group .data-feature');
                    [...items].forEach(item => {
                        featureIds.push($(item).attr('data-feature'));
                    });

                    featureIds.forEach(featureId => {
                        this.mapControl.selectFeature(layerId, featureId, true, false, true);
                    });

                    setTimeout(() => {
                        this._hideMultipleSelection();
                        $('.toolbar-selected-items-wrapper')[0].innerHTML = '';
                    }, 100);
                });

                $('.select-feature-btn').on('click', (evt) => {
                    let currentTarget = evt.currentTarget;

                    let featureRow = $(currentTarget).closest('.legend-node').find('.data-feature');
                    let layerId = featureRow.attr('data-layer');
                    let featureId = featureRow.attr('data-feature');

                    if (this.mapControl.selectionHandler.selectionHolder.allowMultiple && !this.mapControl.selectionHandler.copyMode) {
                        if ($(currentTarget).hasClass('btn-primary')) {
                            $(currentTarget).removeClass('btn-primary');
                            $(currentTarget).addClass('btn-secondary');

                            this.mapControl.deselectFeature(layerId, featureId);
                            featureRow.attr('old-state', 0);
                        } else {
                            $(currentTarget).addClass('btn-primary');
                            $(currentTarget).removeClass('btn-secondary');

                            this.mapControl.selectFeature(layerId, featureId, true, false, true);
                            featureRow.attr('old-state', 2);
                        }
                    } else {
                        this.mapControl.selectFeature(layerId, featureId, true, false, true);
                        setTimeout(() => {
                            this._hideMultipleSelection();
                        }, 100);
                    }
                });

                $('.data-feature').on('mouseenter', (evt) => {
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');

                    let oldState = this.mapControl.highlightFeature(layerId, featureId);
                    $(currentTarget).attr('old-state', oldState);
                });

                $('.data-feature').on('mouseleave', (evt) => {
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');

                    let oldState = $(currentTarget).attr('old-state');

                    if (oldState == null) {
                        oldState = 0;
                    }

                    this.mapControl.unhighlightFeature(layerId, featureId, oldState);
                });

                $('.feature-row-action-btn').on('click', (evt) => {
                    evt.stopPropagation();
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');
                    let actionIdx = parseInt($(currentTarget).attr('action-idx'), 10);

                    let actions = this._getRowFeatureActions(layerId, featureId);
                    if (actions[actionIdx] != null) {
                        this._invokeFeatureAction(layerId, featureId, actions[actionIdx]);
                    }
                });

                $('.feature-row-fit-btn').on('click', (evt) => {
                    evt.stopPropagation();
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');

                    this.mapControl.fitFeature(layerId, featureId);
                });

                $('.feature-row-more-btn').on('click', (evt) => {
                    evt.stopPropagation();
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');
                    let inlineCount = parseInt($(currentTarget).attr('data-inline'), 10);

                    this._showFeatureMoreActions(layerId, featureId, inlineCount, currentTarget);
                });
            }, 100);
        });
    }

    // Rulează o acțiune configurată pentru elementul dat: callback-ul acțiunii se
    // bazează pe selectedFeature* și pe faptul că elementul e în selecție (ex:
    // getFeatureDetails caută în selectionHolder), deci întâi îl selectăm.
    _invokeFeatureAction(layerId, featureId, action) {
        this.mapControl.selectFeature(layerId, featureId, true, false, true);

        this.selectedFeatureId = featureId;
        this.selectedFeatureLayerId = layerId;
        this.selectedFeatureLayer = this.mapControl.getLayer(layerId);

        if (action != null && typeof action.callback === 'function') {
            action.callback(null, null, null);
        }
    }

    // Popup custom (ca meniul din legendă) cu acțiunile care nu au încăput inline.
    _showFeatureMoreActions(layerId, featureId, inlineCount, triggerEl) {
        let existingMenu = document.getElementById(this.featureMoreActionsMenuId);
        if (existingMenu != null) {
            existingMenu.remove();
        }

        if (triggerEl == null) {
            return;
        }

        let actions = this._getRowFeatureActions(layerId, featureId);
        let remaining = actions.slice(inlineCount);

        if (remaining.length == 0) {
            return;
        }

        let rect = triggerEl.getBoundingClientRect();
        let top = rect.bottom + 4;
        let right = window.innerWidth - rect.right;

        let itemsTemplate = '';
        remaining.forEach((action, idx) => {
            itemsTemplate += '<div class="feature-more-action-item" data-remaining-idx="' + idx + '" style="padding: 6px 12px; cursor: pointer; white-space: nowrap;">'
                + '<span class="' + action.icon + '" style="width: 1rem; margin-right: 0.5rem;"></span>'
                + (action.name != null ? action.name : '')
                + '</div>';
        });

        let menuTemplate = '<div id="' + this.featureMoreActionsMenuId + '" style="position: fixed; top: ' + top + 'px; right: ' + right + 'px; z-index: 2000; min-width: 140px; background: #fff; border: 1px solid #d9d9d9; border-radius: 4px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); padding: 4px 0;">'
            + itemsTemplate
            + '</div>';

        document.body.insertAdjacentHTML('beforeend', menuTemplate);

        let menu = document.getElementById(this.featureMoreActionsMenuId);
        if (menu == null) {
            return;
        }

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $(menu).addClass('mod-skin-dark');
        }

        menu.querySelectorAll('.feature-more-action-item').forEach((menuItem) => {
            menuItem.addEventListener('click', () => {
                let remainingIdx = parseInt(menuItem.getAttribute('data-remaining-idx'), 10);
                menu.remove();
                if (remaining[remainingIdx] != null) {
                    this._invokeFeatureAction(layerId, featureId, remaining[remainingIdx]);
                }
            });
        });

        // Închide popup-ul la primul click în afara lui.
        setTimeout(() => {
            let closeHandler = (e) => {
                if (menu != null && !menu.contains(e.target)) {
                    menu.remove();
                    document.removeEventListener('click', closeHandler, true);
                }
            };
            document.addEventListener('click', closeHandler, true);
        }, 0);
    }

    // Acțiunile configurate pe strat, aplicabile unui singur element (min/max
    // selecție încadrează 1) și care au pictogramă.
    _getConfiguredFeatureActions(layerId) {
        let actions = this.actionItems["layer-" + layerId];

        if (actions == null) {
            return [];
        }

        return actions.filter(a => a != null
            && a.icon != null && a.icon.toString().trim() != ''
            && a.minSelection <= 1 && a.maxSelection >= 1);
    }

    // Acțiunile "built-in" din meniul contextual (Informații element, Copiere pe
    // strat, Editare geometrie, Ștergere) modelate ca acțiuni cu callback, ca să
    // treacă prin aceeași conductă ca acțiunile configurate. Fit nu e inclus aici:
    // rămâne butonul fix, mereu al 3-lea vizibil.
    _getBuiltInFeatureActions(layerId, featureId) {
        let builtIns = [];

        if (this.addLayers != null && this.addLayers.length > 0) {
            builtIns.push({
                icon: 'fal fa-copy',
                name: this.resourcesHandler.get('CopyToLayer'),
                callback: () => { this._handleCopyToLayer(layerId); }
            });
        }

        if (layerId == layerTypes.MEASUREMENTS || layerId == layerTypes.REDLINE || layerId == layerTypes.DIMENSIONING) {
            builtIns.push({
                icon: 'fal fa-pencil-ruler',
                name: this.resourcesHandler.get('EDIT_LAYER_GEOMETRY'),
                callback: () => { this._handleEditTemporaryVectorFeature(layerId, featureId); }
            });
        }

        if (layerId == layerTypes.ANNOTATION) {
            builtIns.push({
                icon: 'fal fa-trash',
                name: this.resourcesHandler.get('Remove'),
                callback: () => {
                    let removed = false;
                    let layer = this.mapControl.layerHandler.getLayerById(layerTypes.ANNOTATION)[0];
                    if (layer) {
                        let source = layer.getSource();
                        let feature = source.getFeatures().find(f => f.get('id') == featureId);
                        if (feature) {
                            source.removeFeature(feature);
                            removed = true;
                        }
                    }
                    this._removeContextMenu();
                    this.mapControl.clearSelection();

                    // Dacă elementul a fost șters efectiv, îl scoatem și din arbore.
                    if (removed) {
                        this._removeFeatureFromTree(layerId, featureId);
                    }
                }
            });
        }

        if (this.generalActionHandler.showFeatureInfo) {
            builtIns.push({
                icon: 'fal fa-info-circle',
                name: this.resourcesHandler.get('Feature Information'),
                callback: () => { this._showFeatureInfo(layerId, featureId); }
            });
        }

        return builtIns;
    }

    // Lista combinată afișată pe rândul elementului, fără Fit (care e buton fix).
    // Ordinea: acțiunile configurate au prioritate, apoi cele built-in.
    _getRowFeatureActions(layerId, featureId) {
        return this._getConfiguredFeatureActions(layerId)
            .concat(this._getBuiltInFeatureActions(layerId, featureId));
    }

    // Scoate rândul unui element din arborele de selecție (după ștergere). Dacă
    // stratul rămâne fără elemente, se scoate și nodul stratului; dacă arborele
    // rămâne gol, se ascunde complet.
    _removeFeatureFromTree(layerId, featureId) {
        let treeElement = $('#multiple-layer-selection-tree');
        let treeView = treeElement.data('kendoTreeView');

        if (treeView == null) {
            return;
        }

        let featureRow = treeElement.find('.data-feature').filter((idx, el) => {
            return $(el).attr('data-layer') == layerId && $(el).attr('data-feature') == featureId;
        }).first();

        if (featureRow.length == 0) {
            return;
        }

        let featureNode = featureRow.closest('.k-treeview-item');
        let layerNode = featureNode.closest('.k-treeview-group').closest('.k-treeview-item');

        treeView.remove(featureNode);

        // Dacă stratul nu mai are elemente, îl scoatem și pe el.
        if (layerNode.length > 0 && layerNode.find('.data-feature').length == 0) {
            treeView.remove(layerNode);
        }

        // Dacă arborele a rămas gol, ascundem panoul de selecție.
        if (treeElement.find('.data-feature').length == 0) {
            this._hideMultipleSelection();
        }
    }

    // Elimină clasele de spațiere (ml-*, mr-*, mx-*) dintr-un string de clase,
    // păstrând restul (ex: btn-primary); butonul are propria margine.
    _stripMarginClasses(className) {
        if (className == null || className.toString().trim() == '') {
            return '';
        }

        return className.toString()
            .split(/\s+/)
            .filter(cls => cls != '' && !/^m[lrx]-/.test(cls))
            .join(' ');
    }

    // Butoanele de acțiune din dreapta rândului: maxim 3 vizibile (ultimul fiind
    // mereu „Fit"), restul acțiunilor ajung sub butonul „mai multe".
    _getFeatureRowActionsTemplate(item) {
        let actions = this._getRowFeatureActions(item.layerId, item.featureIdentifier);

        // Din cele 3 sloturi vizibile, ultimul e rezervat pentru Fit, deci maxim
        // 2 acțiuni configurate rămân inline; ce trece peste merge în popup.
        let inlineCount = Math.min(actions.length, 2);
        let hasMore = actions.length > inlineCount;

        let buttonStyle = 'flex: 0 0 auto; min-width: 1rem; width: 1rem; height: 1rem; line-height: 0.6rem; font-size: 0.6rem; margin-left: 0.35rem;';

        let template = '<span class="ml-auto data-feature-actions" style="display: flex; align-items: center; flex: 0 0 auto;">';

        for (let i = 0; i < inlineCount; i++) {
            let action = actions[i];
            // Clasa butonului vine din configurarea acțiunii (ClassName), fără
            // clasele de spațiere (ml-*/mr-*) care ar bate cu marginea proprie a
            // butonului; dacă lipsește, cădem pe btn-secondary.
            let actionClass = this._stripMarginClasses(action.className);
            if (actionClass == '') {
                actionClass = 'btn-secondary';
            }
            template += '<span action-idx="' + i + '" data-layer="' + item.layerId + '" data-feature="' + item.featureIdentifier + '" title="' + (action.name != null ? action.name : '') + '" class="' + action.icon + ' btn ' + actionClass + ' feature-row-action-btn" style="' + buttonStyle + '"></span>';
        }

        // Fit e mereu ultimul buton vizibil.
        template += '<span data-layer="' + item.layerId + '" data-feature="' + item.featureIdentifier + '" title="' + this.resourcesHandler.get('Fit element') + '" class="fal fa-compress-arrows-alt btn btn-secondary feature-row-fit-btn" style="' + buttonStyle + '"></span>';

        if (hasMore) {
            template += '<span data-layer="' + item.layerId + '" data-feature="' + item.featureIdentifier + '" data-inline="' + inlineCount + '" title="' + this.resourcesHandler.get('More') + '" class="fal fa-ellipsis-h btn btn-secondary feature-row-more-btn" style="' + buttonStyle + '"></span>';
        }

        template += '</span>';

        return template;
    }

    _getTooltipContent(template, feature) {
        if (template == null || template.trim() == '' || feature == null) {
            return;
        }

        var tooltip = template;

        var properties = feature;

        let currentLayerSettings = this.mapControl.layerSettingsHandler.getLayerSettings(feature.layerId);
        let layerFields = {};

        if (currentLayerSettings.Type == 'GEOSERVICE' || currentLayerSettings.Type == 'TEMPORARY_VECTOR'){
            let rawProps = Object.keys(properties);

            rawProps.forEach(rawProp => {
                layerFields[rawProp] = {};
            });
        }else{
            currentLayerSettings.Fields.forEach(field => {
                layerFields[field.FieldName] = {};
                layerFields[field.FieldName + '_fktext'] = {};
            });
        }

        for (var k in layerFields) {
            while (tooltip.indexOf("{" + k + "}") > -1) {
                tooltip = tooltip.replace("{" + k + "}", (properties[k] == null || properties[k] === '') ? "-" : properties[k]);
            }
        }

        if (tooltip == null || tooltip.trim() == "") {
            return;
        }

        return tooltip;
    }

    _deselectAllMultipleLayerSelections() {
        $('.select-feature-btn').removeClass('btn-primary');
        $('.select-feature-btn').addClass('btn-secondary');
        $('.select-feature-btn').parent().attr('old-state', 0);
    }

    _hideMultipleSelection() {
        $('.map-toolbar-selected-items').hide();
        if ($('.toolbar-selected-items-wrapper').length > 0) {
            $('.toolbar-selected-items-wrapper')[0].innerHTML = '';
        }
        $(".map-toolbar-selection-list").removeClass('joined');
    }

    _getStylePreview(styleId, classIdx) {
        var url = rootURL + 'img/style/' + styleId + '_' + classIdx + '.png';
        return url;
    }

    _getLegendImageURL(layerConfig, rule) {
        var url = rootURL + 'style/GetLegendGraphicNative?idMap=' + this.mapControl.mapId + '&idMapLayer=' + layerConfig.Id + '&ruleName=' + rule + '&width=24&height=24';
        return url;
    }

    _getEntityDetails(entityId) {
        let entityDetailsUrl = this.rootURL + 'Entity/GetFields?id=' + entityId;
        return $.ajax({
            type: "GET",
            url: entityDetailsUrl,
            contentType: "application/json; charset=utf-8"
        });
    }

    _initModal(title, height, width, url, isModal) {
        if ($('#multipleLayerSelectionModal').length == 0) {
            $('body').append('<div id="multipleLayerSelectionModal"></div>');
        }

        $('#multipleLayerSelectionModal').append('<div id="multiple-layer-selection-modal-inner" style="padding: 0.5rem 0rem !important; padding-left: 0.5rem !important;"></div>');

        if (this._checkMobile()) {
            width = '100%';
            height = 'auto';
            maxHeight = 'calc(100% - 3.8rem)';
        }

        let modalOptions = {
            draggable: true,
            resizable: true,
            width: width != null ? width : "auto",
            height: "auto",
            maxHeight: height,
            title: title,
            modal: isModal,
            close: () => { this._closeModal(); }
        };

        if (url != null) {
            modalOptions.content = {
                url: url
            };
        }

        $('#multiple-layer-selection-modal-inner').kendoWindow(modalOptions);

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }
    }

    _checkMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    _centerModal() {
        $('#multiple-layer-selection-modal-inner').data("kendoWindow").center();
    }

    _closeModal() {
        $('#multiple-layer-selection-modal-inner').data("kendoWindow").destroy();
    }

    _getFeatureSelectionChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let selectedFeatures = data.features;
                this.selectedFeatureId = selectedFeatures == null ? null : selectedFeatures[0];
                this.selectedFeatureLayerId = data.layerId;
                this.selectedFeatureLayer = data.layer;

                if (this.selectedFeatureId == null || this.selectedFeatureLayerId == null) {
                    $(this.mapContainer).css({ "cursor": "default" });
                    if (this.contextMenu != null) {
                        this.contextMenu.hide();
                    }
                } else {
                    if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT) {
                        $(this.mapContainer).css({ "cursor": "url('" + this.rootURL + "img/cursor/cm.gif'), auto" });
                    }
                }
            }
        };

        return handler;
    }

    _removeContextMenu() {
        if (this.contextMenu != null) {
            this.contextMenu.hide();
            //if (this.currentActionType == actionTypes.CLICK || this.currentActionType == actionTypes.DOUBLE_CLICK) {
            //    $event.notify("contextMenuVisibilityChanged", { visible: false }, this);
            //}
        }
    }

    _getFeatureMenuTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='feature-modal-wrapper' id="` + this.featureMenuElementId + `">
                        </div>`;
        return div.firstChild;
    }

    _getFeatureInfoTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.featureInfoWrapper + `">
                    <div class="general-settings-panel panel-container feature-info-modal">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('Feature Information') + `</label>
                            </div>
                            <div class="form-row mb-0 p-4" id="` + this.featureInfoContainer + `" style="max-height: calc(80vh - 6rem); overflow-y: auto; width: calc(100% - 5px);">
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelFeatureInfoId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                        </div>
                    </div>
                </div>`;
    }
}
